<template>
  <el-container  type="flex" class="main_container">
    <base-header>
      机器人总量：{{this.content.bot_total_count}}<span>&emsp;&emsp;</span>
      机器人总进群数：{{this.content.bot_chatroom_total_count}}<span>&emsp;&emsp;</span>
      空闲机器人数：{{this.content.idle_bot_count}}<span>&emsp;&emsp;</span>
      剩余可用群：{{this.content.chatroom_count_remain}}
    </base-header>
    <el-main>
      <div class="chart_box">
        <base-chart
          chartUrl="join_chatroom_daily"
          chartText="机器人进群数量"
          want="join_chatroom_count"
          :total="total_day"
        ></base-chart>
        <base-chart
          chartUrl="join_chatroom_monthly"
          chartText="机器人进群数量"
          want="join_chatroom_count"
          :total="total_month"
        ></base-chart>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import chartMixin from '../../../../mixins/chart'

export default {
  name: 'DBBot',
  mixins: [chartMixin]
}
</script>
